import ApolloClient from 'apollo-boost'
import { GRAPH_API } from '../config'

export const client = new ApolloClient({
  uri: GRAPH_API,
})
